module.exports = __webpack_public_path__ + "img/anonim.96b85d08.png";